import React from "react";
import Indicadores from "../indicadores-campo-web/Indicadores-campo-web";

const IndicadorCampoWeb = () => {
  return (
    <section className="section-container">
      <Indicadores/>
    </section>
  );
};

export default IndicadorCampoWeb;
